var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBook = function SvgBook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    x: 2,
    y: 2,
    fill: "#E2FFEA",
    rx: 18
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    x: 2,
    y: 2,
    stroke: "#F4FFF7",
    strokeWidth: 4,
    rx: 18
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#51C394",
    d: "M27.916 10v20h-13.75q-.517 0-.967-.195-.45-.196-.8-.537a2.3 2.3 0 0 1-.538-.791 2.7 2.7 0 0 1-.195-.977v-15q0-.478.205-.928t.557-.8.8-.557.938-.215zm-1.25 16.25h-12.5q-.264 0-.488.098-.225.098-.39.263-.168.166-.274.4a1.06 1.06 0 0 0-.098.489q0 .264.098.488.098.225.263.39.167.168.4.274.236.108.489.098h12.5zm-13.75-.918q.585-.332 1.25-.332h12.5V11.25h-12.5q-.225 0-.45.107-.223.108-.4.293a1.7 1.7 0 0 0-.283.4q-.107.216-.117.45zm2.5-11.582h8.75v3.75h-8.75zm1.25 2.5h6.25V15h-6.25z"
  })));
};
export default SvgBook;